<div class="card mb-2">
  <div class="card-header">
    Details
  </div>
  <div class="card-body">
    <div fxLayout="column" fxLayoutAlign="space-between none">
      <div>
        <table class="table">
          <thead>
            <tr>
              <th class="bg-primary-subtle"></th>
              <th class="bg-primary-subtle">Current</th>
              <th class="bg-primary-subtle">Potential</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>CO₂ emissions</td>
              <td>{{ eeStatusDetails ? (eeStatusDetails.co2EmissionCurrent + " tonnes") : "-" }}</td>
              <td>{{ eeStatusDetails ? (eeStatusDetails.co2EmissionPotential + " tonnes") : "-" }}</td>
            </tr>
            <tr>
              <td>Primary energy usage</td>
              <td>{{ eeStatusDetails ? (eeStatusDetails.primaryEnergyUseCurrent + " kWh/m²") : "-" }}</td>
              <td>{{ eeStatusDetails ? (eeStatusDetails.primaryEnergyUsePotential + " kWh/m²") : "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  </div>
